export default "__VITE_ASSET__CjfyVpzT__"